"use client"

import { useInView } from "react-intersection-observer"

import {Sprout, TreePine } from "lucide-react"
import "../assets/css/services.css"
import plantImg from "../assets/images/plants.webp"
import bagImg from "../assets/images/bags.webp"

export default function Services() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  })

  const services = [
    {
      icon: <Sprout className="service-icon-svg" />,
      title: "Grow Bags",
      description:
        "High-quality grow bags for home gardening and commercial cultivation. Perfect for vegetables, herbs, and small plants.",
      image: bagImg,
      features: ["Various sizes available", "Durable material", "Excellent drainage", "Reusable"],
    },
    {
      icon: <TreePine className="service-icon-svg" />,
      title: "Plants",
      description: "Wide variety of healthy plants including vegetables, herbs, ornamental plants, and fruit trees.",
      image: plantImg,
      features: ["Healthy seedlings", "Expert care", "Disease-free plants", "Growing guidance"],
    },
    // {
    //   icon: <Leaf className="service-icon-svg" />,
    //   title: "Seeds & Saplings",
    //   description: "Premium quality seeds and saplings for various crops including chilies, vegetables, and herbs.",
    //   image: "/placeholder.svg?height=300&width=400",
    //   features: ["High germination rate", "Organic varieties", "Seasonal availability", "Growing instructions"],
    // },
    // {
    //   icon: <Package className="service-icon-svg" />,
    //   title: "Gardening Supplies",
    //   description: "Complete range of gardening tools, fertilizers, and accessories for successful cultivation.",
    //   image: "/placeholder.svg?height=300&width=400",
    //   features: ["Quality tools", "Organic fertilizers", "Pest control", "Expert advice"],
    // },
  ]

  return (
    <section id="services" ref={ref} className="services-section">
      <div className="services-container">
        <div className="section-header">
          <h2 className={`section-title ${inView ? "visible" : ""}`}>Our Services</h2>
          <div className={`section-divider ${inView ? "visible" : ""}`}></div>
          <p className={`service-subtitle ${inView ? "visible" : ""}`}>
            We provide comprehensive gardening and agricultural services to help you grow successfully
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className={`service-card ${inView ? "visible" : ""}`}
              style={{
                transitionDelay: `${300 + index * 150}ms`,
              }}
            >
              <div className="service-image">
                <img src={service.image || "/placeholder.svg"} alt={service.title}  className="image" />
                <div className="service-icon-overlay">{service.icon}</div>
              </div>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="service-feature">
                      <div className="feature-bullet"></div>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Background decoration */}
      <div className="bg-shape bg-shape-1"></div>
      <div className="bg-shape bg-shape-2"></div>
    </section>
  )
}
